var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row"},[_c('default-edit-button',{on:{"click":_vm.edit}}),_c('default-remove-button',{on:{"click":_vm.remove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }